<template>
  <el-dialog :title="id==null ? '新增建筑' : '编辑建筑'" :visible.sync="orgVisible" width="650px" :modal-append-to-body='false' :before-close="handleClose2" :close-on-click-modal="false" center>
    <div class="from-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto" class="demo-ruleForm">
        <el-form-item label="建筑名称" prop="name">
          <!-- {{ ruleForm.parent }} -->
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose2">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentData:{},

      ruleForm: {
        id: null,
        name: null,
        parent: null,
        project:null,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写建筑名称",
            trigger: "blur",
          },
        ]
      },
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["orgVisible","parentId","id","name","project"],
  watch: {
    orgVisible(newVal) {
      if (newVal) {
        this.ruleForm.id=this.id;
        this.ruleForm.parent=this.parentId;
        this.ruleForm.name=this.name;
        this.ruleForm.project=this.project;

      }
    }
  },
  methods: {
    handleClose2() {
      this.ruleForm.name = ""; 
      this.ruleForm.parent = 0;
      this.$refs["ruleForm"].resetFields();
      this.$emit("handleClose2");
    },
    //确定
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.ruleForm.id==null) {
            this.request.placeAdd(this.ruleForm).then((res) => {
              if (res.code==0) {
                this.$emit("listOrg");
                this.handleClose2();
              }
            });
          } else {
            this.request.placeEdit(this.ruleForm).then((res) => {
              if (res.code==0) {
                this.$emit("listOrg");
                this.handleClose2();
              }
            });
          }
        }
      });
    },
  },
};
</script>


<style scoped>
.from-body {
  padding: 0 60px;
  box-sizing: border-box;
}
</style>